export default __webpack_public_path__ + "static/media/rsFlag.a87368f7.svg";